import reducerRegistry from '../../../../helpers/ReducerRegistry';
import strategyService from '../../../../../core/services/Strategy/StrategyService';

// ================================================== CONSTANTS ========================================================
const REDUCER_NAME = 'OVERVIEW';
const FETCH_OVERVIEW_DATA = `${REDUCER_NAME}FETCH_OVERVIEW_DATA`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

// =================================================== EXPORT ==========================================================
export { REDUCER_NAME, reducer as default };

// =================================================== ACTIONS =========================================================
export const fetchOverviewData = params => {
  return dispatch => {
    strategyService.getOverView(params).then(response => {
      let { items = [] } = response === null ? [] : response || [];
      dispatch({
        type: FETCH_OVERVIEW_DATA,
        payload: {
          overViewData: items && items.length ? items[0] : {},
        },
      });
    });
  };
};

// ================================================== REDUCE ===========================================================
const initialState = {
  overViewData: [],
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case FETCH_OVERVIEW_DATA: {
      const { overViewData } = action.payload;
      return {
        ...state,
        overViewData,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
